"use strict";
function createRange(start, end) {
    var range = [];
    for (var i = start; i <= end; i++) {
        range.push(i);
    }
    return range;
}
exports.createRange = createRange;
//# sourceMappingURL=ultimate-pagination-utils.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/ultimate-pagination/lib/ultimate-pagination-utils.js
// module id = 874
// module chunks = 0